import React from 'react';
import Fb from 'assets/icons/fb.png';
import Twit from 'assets/icons/twit.png';
import In from 'assets/icons/in.png';
import Quora from 'assets/icons/quora.png';
import Ridit from 'assets/icons/ridit.png';
import { Image } from 'react-bootstrap';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  RedditShareButton,
} from 'react-share';

function SocialShare({ event: data }) {
  return (
    <>
      <FacebookShareButton url={data.url} quote={data?.name?.text}>
        <Image src={Fb} className="mr-2 pointer" />
      </FacebookShareButton>
      <LinkedinShareButton
        url={data.url}
        title={data?.name?.text}
        summary={data?.summary}
        source="Cap 60"
      >
        <Image src={In} className="mr-2 pointer" />
      </LinkedinShareButton>
      <TwitterShareButton url={data?.url} title={data?.name?.text}>
        <Image src={Twit} className="mr-2 pointer" />
      </TwitterShareButton>
      <Image src={Quora} className="mr-2 pointer" />
      <RedditShareButton url={data?.url} title={data?.name?.text}>
        <Image src={Ridit} className="mr-2 pointer" />
      </RedditShareButton>
    </>
  );
}

export default SocialShare;
